import React from 'react';

import { SVGIconProps } from '@/models/';

export default (props: SVGIconProps) => {
  const newProps = { ...props };
  delete newProps.alt;
  delete newProps.title;

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...newProps} role="img">
      {props.title && <title>{props.title}</title>}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7071 1.29292C23.0059 1.59175 23.0847 2.04618 22.9037 2.42811L13.4301 22.4281C13.2492 22.8098 12.8481 23.0368 12.4278 22.9952C12.0075 22.9535 11.6586 22.6523 11.5562 22.2426L9.59643 14.4036L1.75747 12.4439C1.3477 12.3414 1.04649 11.9926 1.00487 11.5723C0.963249 11.1519 1.1902 10.7508 1.57192 10.57L21.5719 1.09629C21.9538 0.915375 22.4083 0.994089 22.7071 1.29292ZM4.95335 11.1813L10.6636 12.6088C11.0219 12.6984 11.3016 12.9782 11.3912 13.3364L12.8188 19.0467L19.8976 4.10241L4.95335 11.1813Z"
      />
    </svg>
  );
};
